import type { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';

import { SECTIONS_WITHOUT_NOTIFICATIONS_BAR } from 'constants/notification-bar';
import { getVisibleNotifications } from 'helpers/notification-bar';
import { type ITopBarNotification } from 'interfaces/notification-bar';
import { NotificationsBarActions } from 'store/features/notifications-bar/actions';

import { getNotifications } from '../notifications-bar/selectors';
import { getCanManageSubscription } from '../session/selectors';

import { RoutingActionsEnum, type RoutingAction } from './actions';
import { getIsPreviousSection, type IWithRoutingState } from './selectors';

function* watchRouteChange(action: RoutingAction): SagaIterator {
  if (action.type !== RoutingActionsEnum.SET_CURRENT_SECTION) {
    return;
  }

  const route = action.payload.route;
  const isPreviousSection = yield select((state: IWithRoutingState) => getIsPreviousSection(state, route));

  if (isPreviousSection) {
    return;
  }

  const shouldCollapseNotifcationBar = SECTIONS_WITHOUT_NOTIFICATIONS_BAR.some((section) => route.startsWith(section));
  const notifications = yield select(getNotifications);
  const canManageSubscription = yield select(getCanManageSubscription);
  const hasVisibleNotifications =
    getVisibleNotifications(notifications as ITopBarNotification[], canManageSubscription as boolean).length > 0;

  if (shouldCollapseNotifcationBar || !hasVisibleNotifications) {
    yield put(NotificationsBarActions.hideAllNotificationsBar());
  } else {
    yield put(NotificationsBarActions.showAllNotificationsBar());
  }
}

export function* routingSaga(): SagaIterator {
  yield takeEvery(RoutingActionsEnum.SET_CURRENT_SECTION, watchRouteChange);
}
